import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import Footer from '../../components/Footer';
import CompareMain from './CompareMain';

const Compare = () => {
  return (
    <>
      <HeaderSeven />

      <CompareMain />

      <Footer />
    </>
  );
};

export default Compare;
